import { Button } from "./ui/button";
import { Phone, Calendar } from "lucide-react";

const DesktopStickyCTA = () => {
  return (
    <div className="hidden md:flex fixed bottom-8 right-8 z-50 gap-3 animate-fade-in" role="navigation" aria-label="Quick contact actions">
      <a 
        href="tel:+13369624539" 
        className="group"
        aria-label="Call Neil AI at 336-962-4539"
      >
        <Button
          size="lg"
          className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold rounded-full shadow-2xl flex items-center gap-2 focus:ring-2 focus:ring-primary focus:ring-offset-2 transition-all hover:scale-105"
        >
          <Phone className="h-5 w-5" aria-hidden="true" />
          <span className="hidden lg:inline">Call (336) 962-4539</span>
        </Button>
      </a>
      
      <a 
        href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="group"
        aria-label="Book a demo with Neil AI (opens in new window)"
      >
        <Button
          size="lg"
          className="bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold rounded-full shadow-2xl flex items-center gap-2 shadow-[0_0_20px_rgba(0,255,200,0.4)] focus:ring-2 focus:ring-secondary focus:ring-offset-2 transition-all hover:scale-105"
        >
          <Calendar className="h-5 w-5" aria-hidden="true" />
          <span className="hidden lg:inline">Book Demo</span>
        </Button>
      </a>
    </div>
  );
};

export default DesktopStickyCTA;
